/** UpgradeCard — the one card shown wherever content needs premium: what is locked, one button. The button runs the same upgrade flow everywhere. */
import { Clock, Lock } from "lucide-react";
import { Button } from "../ui/Button";
import { useStudent } from "../../context/StudentContext";

type Props = {
  /** One short line: what the student gets by upgrading. */
  message: string;
  title?: string;
  /** Semester the locked content belongs to, so the upgrade page opens on the right plan. */
  semester?: number | null;
  stream?: string | null;
  /** "stack": brand-coloured card laid over blurred locked rows. */
  variant?: "default" | "stack";
};

export function UpgradeCard({ message, title = "Premium", semester, stream, variant = "default" }: Props) {
  const { openUpgrade, hasPendingRequest } = useStudent();
  const pending = hasPendingRequest(semester ?? null);
  const stack = variant === "stack";
  return (
    <div className={stack ? "flex flex-col items-start gap-3 rounded-card bg-primary p-5 text-on-accent shadow-lg" : "flex flex-col items-start gap-3 rounded-card border border-border bg-card p-5"}>
      <span className={stack ? "flex h-11 w-11 items-center justify-center rounded-full bg-card text-primary" : "flex h-11 w-11 items-center justify-center rounded-full bg-accent-soft text-primary"} aria-hidden="true">
        {pending ? <Clock size={20} /> : <Lock size={20} />}
      </span>
      <div className="space-y-1">
        <p className="text-base font-semibold">{pending ? "Payment awaiting review" : title}</p>
        <p className={stack ? "text-sm" : "text-sm text-muted-foreground"}>{pending ? "We will unlock this as soon as your payment is confirmed." : message}</p>
      </div>
      {!pending && <Button variant={stack ? "secondary" : "primary"} onClick={() => openUpgrade(semester || stream ? { semester, stream } : undefined)}>Upgrade to Premium</Button>}
    </div>
  );
}
